import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/admins/$userId")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+UserPage")),
  beforeLoad: () => ({
    breadcrumb: "Edit User",
  }),
});
